import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'functions_as_params',
    dependencies: [
        'levels/composed_functions',
        'levels/functions_as_vars'
    ]
})



level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 5)
        let b = random.intBetween(0, 5)
        if (b === a) {
            b += 2
        }
        let name = random.fairChoice(['hi', 'hello'], {name: 'methodName'})
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'


            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nfunction bonjour (hahaha) {'
            + '\n\treturn hahaha(' + a + ', ' + b + ')'
            + '\n}'

            + '\n\nbonjour(' + name + ')'
        )
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 3)
        let b = random.intBetween(0, 3)
        if (b === a) {
            b += 2
        }
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nfunction bonjour (hahaha) {'
            + '\n\treturn hahaha(' + a + ', ' + b + ')'
            + '\n}'

            + '\n\nbonjour(hello) + bonjour(hi)'
        )
    }
})




export default level

